export default {
  breadcrumbs: {
    invites: 'Invites',
    newInvite: 'New Invite',
    reviewInvite: 'Review Invite',
    myChannel: 'My Channel',
  },
  welcomeMessage: {
    title: 'Welcome Commissioner!',
    description1:
      'If you want to send an email from your favorite email client, copy your invite link below.  You can access your List by clicking on the RYP or OFP tab below, selecting your contest name, and then clicking the CSV button. This will download the email addresses of members from that contest.',
    description2:
      'You can also send invitations through the Splash Platform. To re-invite past members, click on your pool or contest under the relevant tab and select "Review Invite." Previously hosted pools on RYP or OfficeFootballPool (OFP) can be accessed under their respective tabs. On the Splash platform, "Followers" refers to users who follow you, and "Groups" are contests you’ve previously hosted. Once invitations are sent, you can track them using the "Invites" widget on the left side of the screen.',
    closeButton: 'Got it',
  },
  tabs: {
    followers: 'Followers',
    followersWithCount: 'Followers ({{followersCount}})',
    allFollowers: 'Select all followers on this page ({{followersCount}})',
    members: 'Entrants',
    membersWithCount: 'ENTRANTS ({{membersCount}})',
    groups: 'Groups',
    groupsWithCount: 'Groups ({{groupsCount}})',
    groupsMembersWithCount: 'Groups members ({{groupsMembersCount}})',
    rypPoolsWithCount: 'RYP pools ({{poolsCount}})',
    rypMembersWithCount: 'RYP members ({{membersCount}})',
    rypPoolsWithCountExcluded: 'RYP members excluded ({{poolsCount}} - {{excludedCount}})',
    ofpPoolsWithCount: 'OFP pools ({{poolsCount}})',
    ofpMembersWithCount: 'OFP members ({{membersCount}})',
    ofpPoolsWithCountExcluded: 'OFP members excluded ({{poolsCount}} - {{excludedCount}})',
    allContests: 'Select all contests on this page ({{contestsCount}})',
    email: 'Email',
    ryp: 'RYP',
    ofp: 'OFP',
    link: 'Link',
  },
  tabsv3: {
    newEmails: 'Import emails',
    emails: 'Email',
    link: 'Share link',
    followers: 'Followers',
    contests: 'Previous Splash entrants',
    ryp: 'RunYourPool',
    ofp: 'OfficeFootballPool',
    other: 'Other',
  },
  checkBoxLabels: {
    contests: 'CONTESTS',
    entrants: 'ENTRANTS',
    followers: 'FOLLOWERS',
  },
  filter: {
    all: 'All',
    followers: 'Followers',
    groups: 'Previous Splash entrants',
    emails: 'Email imports',
    ryp: 'RunYourPool',
    ofp: 'OfficeFootballPool',
    allCount: 'All ({{count}})',
    followersCount: 'Followers ({{count}})',
    groupsCount: 'Previous Splash entrants ({{count}})',
    rypCount: 'RunYourPool ({{count}})',
    ofpCount: 'OfficeFootballPool ({{count}})',
    emailCount: 'Emails ({{count}})',
  },
  newInvite: {
    selectedInvites: 'Invite ({{count}})',
    title: 'Add to invite',
    loadError: {
      title: 'Unable to load contests',
      description: 'Please try again.',
      retry: 'Retry',
    },
    emptyState: {
      contest: {
        title: 'No previous {{type}} contests',
        description:
          'You haven’t run any contests on {{type}}. Your previous contests will appear here. Select and add entrants from previous contests to the invite.',
      },
      search: {
        title: 'No results found',
        description:
          'Try adjusting your search terms or clear the search to see all {{type}} contests.',
      },
      newInvite: {
        live: 'No longer available for live contests',
        complete: 'No longer available for this contests',
      },
      title: 'Not available for live contests',
      description:
        'You can only send new invites for upcoming contests. Review your invites on the <link>Sent</link> tab.',
    },
  },
  sentInvite: {
    title: 'Sent invites',
    emailButton: 'Send reminder',
    downloadButton: 'Download',
    searchPlaceholder: 'Search by name, handle, or email',
  },
  search: {
    placeholder: {
      default: 'Search',
      followers: 'Search followers',
      groups: 'Search Splash contests',
      ryp: 'Search RunYourPool contests',
      ofp: 'Search OfficeFootballPool contests',
    },
    helperText: 'Please type more characters to search',
  },
  container: {
    new: 'New invite',
    sent: 'Sent ({{count}})',
  },
  commitSelections: 'Add ({{count}})',
  sendNewInvite: 'Send new invite',
  resendInvites: 'Send reminder',
  reviewInvite: 'Review invite',
  sendInvite: 'Send invite',
  sending: 'Sending...',
  addCustomMessage: 'Add a custom message to the invite',
  availableInMobileApp: 'Currently available only in mobile apps',
  noResults: {
    title: 'No invites sent',
    // text: 'Send a contest invite to followers or copy/paste the contest link.',
    text: 'Go to the <link>New invite</link> tab to send invites, or click the <bold>Copy invite link</bold> button above to share the invite link directly.',
  },
  noSearchResults: {
    title: 'No results',
    text: 'There are no sent invites that match your search and/or filters.',
  },
  noSearchResultsPendingInvites: {
    title: 'No results',
    text: 'There are no results that match your search and/or filters.',
  },
  noSelections: {
    title: 'No people added',
    text: 'Use the *Add to invite* section to add people to the invite. Review and send the invite here.',
  },
  entrants: 'Entrants',
  error: {
    title: 'Something went wrong',
    text: 'Please try again later.',
  },
  emails: {
    reset: 'Clear',
    submit: 'Import',
    noResults: {
      title: 'No emails imported',
      text: 'Imported emails will appear here for you to manage and add to the invite.',
    },
  },
  notifications: {
    successBefore: {
      message: 'Inviting players... (this may take a few minutes)',
      sendEmail: 'Sending emails... (this may take a few minutes)',
    },
    successAfter: {
      message__hasPlural: {
        one: '1 invite sent successfully!',
        other: '{{count}} invites sent successfully!',
      },
      sendEmail__hasPlural: {
        one: '1 email sent successfully!',
        other: '{{count}} emails sent successfully!',
      },
    },
    error: {
      title: 'Could not send invitations',
      message: 'There was an error sending the invitations. Please try again later.',
    },
    errorEmail: {
      title: 'Could not send emails',
      message: 'There was an error sending the emails. Please try again later.',
    },
  },
  stats: {
    emailInvites: 'EMAIL INVITES',
    info: 'A breakdown of Invites, Entered and Pending is only available for invites sent to followers or contests.',
    entriesAvailable: 'ENTRIES AVAILABLE',
    invites: 'INVITES',
    entered: 'ENTERED',
    pending: 'PENDING',
    invited: 'INVITES ({{totalCount}})',
    sent: 'SENT',
    status: 'STATUS',
  },
  noFollowers: {
    title: 'No followers yet',
    text: 'Your followers will be listed here to select and add to the invite.',
    searchTitle: 'No results found',
    searchText: 'Try adjusting your search terms or clear the search to see all followers.',
  },
  noGroups: {
    title: 'No groups',
    text: 'When you run a contest, Splash automatically creates a group of your entrants so you can easily invite past entrants to your new contest.',
  },
  review: {
    info: 'Invites will not be sent to players you already invited or players that already entered this contest.',
    noFollowers: {
      title: 'No followers added',
      text: 'Go back to add followers to the invite.',
    },
    noGroups: {
      title: 'No groups added',
      text: 'Go back to add groups to the invite.',
    },
    noRyp: {
      title: 'No RYP pools added',
      text: 'Go back to add RYP pools to the invite.',
    },
    noOfp: {
      title: 'No OFP pools added',
      text: 'Go back to add OFP pools to the invite.',
    },
  },
  form: {
    placeholder: `Enter or paste emails to import.\n •  Separate emails with a comma and/or space.\n •  Duplicate emails will not be imported.`,
    info: 'Need to import more emails? <link>Request a VIP Status</link>. Reminder: use of the <inviteLink>invite link</inviteLink> is unlimited.',
    infoOverLimit:
      'A maximum of {{cap}} total emails are permitted per contest. You can still use the <inviteLink>invite link</inviteLink> or add users from previous contests. <link>Request a VIP access here</link>.',
    emailLimit: {
      title: 'Email limit reached',
      message: 'To import more than 1,000 emails, please contact VIP Support.',
    },
  },
  importEmails: {
    emptyState: {
      title: 'Currently unavailable',
      description: 'Need to import a large list?',
      linkText: 'Use VIP Support',
    },
  },
  ryp: {
    title: 'Link your RYP account',
    description: 'With linked RYP account, you can invite players from your RYP pools.',
    link: 'Link RYP',
    cta: 'Send new invite',
    allPools: 'Select all contests on this page ({{poolsCount}})',
    noPools: {
      title: 'No pools',
      text: 'Looks like you don’t have any RYP pools.',
    },
    csv: 'CSV',
  },
  ofp: {
    title: 'Link your OFP account',
    description: 'With linked OFP account, you can invite players from your OFP pools.',
    link: 'Link OFP',
    cta: 'Send new invite',
    allPools: 'Select all contests on this page ({{poolsCount}})',
    noPools: {
      title: 'No pools',
      text: 'Looks like you don’t have any OFP pools.',
    },
    csv: 'CSV',
  },
  contests: {
    type: 'TYPE',
    entrants: 'ENTRANTS',
    inProgress: 'In progress',
  },
  processing: {
    alert: 'Your invites are still being processed, please wait before you can send more.',
    button: 'Processing...',
  },
  modals: {
    download: {
      title: 'Download invites list',
      description: 'You can download the contact information of your invited members.',
      descriptionLoading:
        'Please wait while we generate the file. This can take a few seconds depending on the number of invites. Your download will start automatically.',
      cta: 'Download .csv',
      failed: {
        title: 'Download Failed',
        failedToQueue: 'Failed to queue download. Please try again later.',
        failedToGenerate: 'Failed to generate CSV file. Please try again.',
        failedToPoll: 'Failed to check download status. Please try again.',
      },
    },
    downloadMembers: {
      title: 'Download members list',
      description: 'You can download the contact information of your members from your past pool.',
      descriptionLoading:
        'Please wait while we generate the file. This can take a few seconds depending on the number of members. Your download will start automatically.',
      cta: 'Download .csv',
      failed: {
        title: 'Download Failed',
        failedMemberDownload: 'Failed to download members. Please try again.',
      },
    },
    tosModal: {
      title: 'Comissioner terms',
      description:
        'As the commissioner, you cannot abuse your list of entrants. Send a new invite to your followers and/or players that entered your contests. Track the status of your invites here.',
      cta: 'Accept and continue',
      failed: {
        title: 'Failed to accept Terms Of Service',
        description: 'There was an error accepting the terms of service. Please try again later.',
      },
    },
    reviewInvites: {
      title: 'Review invite',
      cta: 'Send invite',
    },
  },
  linkModal: {
    description:
      'Copy the link below and paste it into an email, social media site, or any other destination.',
  },
  secondaryActions: {
    downloadInvites: 'Download invites list',
    downloadMembers: 'Download members list for this pool',
    noInvitesToDownload: 'No invites to download',
    noMembersToDownload: 'No members to download',
    copyLink: 'Copy invite link',
    copyLinkButton: 'Copy link',
  },
  welcomeMessageV3: {
    title: 'GUIDE',
    subTitle: 'Invites Manager',
    inviteLink: {
      title: 'Share invite link',
      description:
        '<0>Copy the invite link to send direct invites, or use the <1>Add invitees</1> section to:</0>',
      item1: 'Import email lists',
      item2: 'Invite your Splash followers',
      item3: 'Invite users from past contests on Splash, RYP, or OfficeFootballPool',
    },
    trackInvites: {
      title: 'Track invites',
      description: 'You can track invitation status anytime on the Sent tab.',
    },
    reviewSettings: {
      title: 'Review settings',
      description:
        'Please review your contest settings before sending invites, as some settings can’t be changed once users join.',
    },
  },
  commissionerCallout: {
    title: 'Welcome Commissioner!',
    description1: `If you want to send an email from your favorite email client, copy your invite link below.  You can access your List by clicking on the RYP or OFP tab below, selecting your contest name, and then clicking the CSV button. This will download the email addresses of members from that contest.`,
    description2: `You can also send invitations through the Splash Platform. To re-invite past members, click on your pool or contest under the relevant tab and select "Review Invite." Previously hosted pools on RYP or OfficeFootballPool (OFP) can be accessed under their respective tabs. On the Splash platform, "Followers" refers to users who follow you, and "Groups" are contests you've previously hosted. Once invitations are sent, you can track them using the "Invites" widget on the left side of the screen.`,
  },
  inviteListTooltip: {
    overview: 'All names listed below have received an email with an invitation to your contest.',
    entriesAvailable: 'Entries Available: The number of open slots you have left in your contest.',
    invites:
      'Invites: The total number of people you have invited. This includes both ’Entered’ and ’Pending’ invites.',
    entered: 'Entered: The number of people who have accepted your invite and joined the contest.',
    pending:
      'Pending: The number of people who have received your invite but have not joined the contest.',
  },
  sendCustomEmail: {
    cta: 'Email your invitees',
    dialogue: 'You can only send one email per day.',
  },
  sendEmailModal: {
    title: 'Send email',
    selectTo: 'Select who to send the email to',
    selectFrom: 'Select who to send the email from',
    messagePlaceholder: 'Enter custom message here',
    messageLength: '{{length}}/1,000',
    sendEmail: 'Send email',
    includeLink: 'Include contest invite link in email',
    fullName: 'Full name',
    splashHandle: 'Splash handle',
    allInvitees: 'All invitees',
    pendingInvitees: 'Pending invitees',
    pendingInviteesLower: 'pending invitees',
    to: 'To',
    from: 'From',
    error: {
      message: 'Please enter a message',
    },
  },
  emailsSentConfirmationModal: {
    title: 'Emails sent',
    description: 'You have emailed',
    invitees__hasPlural: {
      one: 'invitee',
      other: 'invitees',
    },
  },
  infoFooter: {
    message: 'To manage invitees that entered your contest, go to',
    linkText: 'Entrants Manager',
  },
  blockedAccess: {
    title: 'Your access to send invites has been restricted',
    description: 'Please <link>contact support</link> to get your access enabled.',
  },
};
